import type { App, Plugin } from "vue";
import JfIcon from "@jfrog/ui-platform-common/components/JfIcon/index.vue";
import JfText from "@jfrog/ui-platform-common/components/JfText/index.vue";

// Vue plugin that registers the global components `@jfrog/ui-platform-common`
// SFCs expect to be globally available. Several common components (e.g.
// AppLauncher) render `<jf-icon>` / `<jf-text>` as globally-resolved tags
// instead of importing them locally, mirroring the platform-ui host which
// registers the whole common component set globally at bootstrap.
//
// `JfIcon` loads its own SVG sprites via `import.meta.glob` (Vite transforms
// that glob even though it lives in node_modules, since the package ships raw
// source and isn't pre-bundled), so registering the component is all that's
// needed for icons inside common components to render.
//
// Use once at app setup, the same way the pinia plugin is wired:
//   app.use(commonGlobalsPlugin);
export const commonGlobalsPlugin: Plugin = {
  install(app: App) {
    app.component("jf-icon", JfIcon);
    app.component("jf-text", JfText);
  },
};
